// Termin złożenia oferty — wspólne formatowanie dla listy wycen i widoku wyniku.
// Wpisywany ręcznie przy wgrywaniu plików (docelowo z importu przetargów ZE).

/** "05.08.2026, 10:00" */
export function fmtDeadline(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString("pl-PL", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/** Dni kalendarzowe do terminu: 0 = dziś, ujemne = po terminie. */
export function daysToDeadline(iso: string): number | null {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  const target = new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
  return Math.round((target - today) / 86_400_000);
}

/** "05.08.2026, 10:00 · za 3 dni" */
export function deadlineLabel(iso: string): string {
  const stamp = fmtDeadline(iso);
  const n = daysToDeadline(iso);
  if (n == null) return stamp;
  if (n < 0) return `${stamp} · po terminie`;
  if (n === 0) return `${stamp} · dziś`;
  if (n === 1) return `${stamp} · jutro`;
  return `${stamp} · za ${n} dni`;
}

/** Czerwony po terminie, pomarańczowy gdy zostały ≤ 2 dni. */
export function deadlineToneClass(iso: string): string {
  const n = daysToDeadline(iso);
  if (n == null) return "";
  if (n < 0) return "text-red-600 font-medium";
  if (n <= 2) return "text-amber-600 font-medium";
  return "";
}

/** ISO z API → wartość dla <input type="datetime-local"> (czas lokalny). */
export function toDateTimeLocal(iso: string | null): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const p = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
}
